import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import React from 'react'
import styled from 'styled-components'
import BusinessTravellerSignupBlurb from './BusinessTravellerSignupBlurb'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import BusinessTravellerBusinessSignupStepper from './BusinessTravellerBusinessSignupStepper'

const ContentContainer = styled(LayoutContainer)`
  padding: 0;

  ${mediaQueryUp.tablet} {
    padding-top: ${rem(40)};
    padding-bottom: ${rem(40)};
  }
`

const FlexPane = styled(Pane)`
  flex-grow: 1;
  background-color: ${props => props.theme.palette.neutral.default.seven};
`

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  ${mediaQueryUp.tablet} {
    gap: ${rem(80)};
    grid-template-columns: ${rem(200)} minmax(0, 1fr);
  }
  ${mediaQueryUp.desktop} {
    grid-template-columns: ${rem(400)} minmax(0, 1fr);
  }
`

function BusinessTravellerSignupPage() {
  return (
    <FlexPane>
      <ContentContainer>
        <ContentGrid>
          <BusinessTravellerSignupBlurb />
          <BusinessTravellerBusinessSignupStepper />
        </ContentGrid>
      </ContentContainer>
    </FlexPane>
  )
}

export default BusinessTravellerSignupPage
